// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    text_delete: 'Zmazať pole',
    text_edit: 'Upraviť pole',
    text_filter: 'Vlastné polia pre',
    text_include_in_unportfolioed_projects: 'Zahrnúť do neportfoliovaných položiek',
    text_isRequired: 'To je povinné',
    text_restricted_by_portfolio: 'Obmedziť portfólia',
};
